define((require) => {
    "use strict";

    const {DateUtil}   = require("shared/util/DateUtil");
    const GroupModel = require("shared/ui/groups/GroupModel");
    const GroupUtil  = require("ui/groups/GroupUtil");
    const Marionette = require("marionette");
    const template   = require("ui/imageLibrary/ImageExperienceItemView.tpl");

    /**
     * Item view for an image experience item
     *
     * @class ImageExperienceItemView
     */
    return Marionette.ItemView.extend({
        tagName: "tr",

        template: template,

        className: "image-experience-item-view",

        templateHelpers() {
            return {
                lastUpdated: DateUtil.formatMMDDYYY(this.model.get("editedAt")),
                experienceName: this.model.get("name"),
                url: this._getUrl()
            };
        },

        _getUrl() {
            let id = this.model.id;

            if (this.model instanceof GroupModel) {
                id = GroupUtil.firstGroupExperience(this.model, this.model.get("entries")).id;
            }

            return `experience/${id}/edit`;
        },

        events: {
            "click": "_experienceItemClicked"
        },

        _experienceItemClicked() {
            this.trigger("clicked:experience:item");
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/imageLibrary/ImageExperienceItemView.js